import { render, staticRenderFns } from "./BookingResponsesListItem.vue?vue&type=template&id=04de23c5"
import script from "./BookingResponsesListItem.vue?vue&type=script&lang=js"
export * from "./BookingResponsesListItem.vue?vue&type=script&lang=js"
import style0 from "./BookingResponsesListItem.vue?vue&type=style&index=0&id=04de23c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports